import * as React from 'react';

import {
  sections,
  // utils
} from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

import { SectionContentLinkListIdEight } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdEight) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdEight]: {
      id: SectionContentLinkListIdEight;
      title: string;
    };
  } = {
    [SectionContentLinkListIdEight.OurContactInformation]: {
      id: SectionContentLinkListIdEight.OurContactInformation,
      title: sections.tabEightSection.tab.title(),
    },
  };

  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionEightContainer = ({ lang }: { lang: SupportedLanguage }) => {
  return {
    sections: {
      one: {
        id: SectionContentLinkListIdEight.OurContactInformation,
        titleElement: setTitleElement(SectionContentLinkListIdEight.OurContactInformation),
        text: (
          <FormattedText>
            <P1 html={sections.tabEightSection.section1.text1()} as="p" />
            <P1 html={sections.tabEightSection.section1.text2()} as="p" />
            <P1 html={sections.tabEightSection.section1.text3()} as="div" />
            <P1
              html={sections.tabEightSection.section1.text4({
                printable_version_link: `/privacy-policy/${lang}/print`,
              })}
              as="p"
            />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-08/tab-08-02.jpg`,
        imageAlt: '',
        imageObjectPosition: '50% 50%',
      },
    },
  };
};
